import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ChildStatisticsTable } from '@app/components/shared/Statistics/Table'
import PillsMenu from '@app/components/parents/PillsMenu'
import BackLink from '@app/components/ui/buttons/BackLink'
import Placeholder from '@app/components/ui/placeholders/Placeholder'
import CertificateButton from '@app/components/ui/buttons/CertificateButton'
import StatisticsContainer from '@app/containers/parents/Statistics'
import { Can } from '@app/context/ability-context'
import Olympiad from '@app/models/olympiad'
import Loader from '@app/components/ui/placeholders/Loader';
import _ from 'lodash'
import classnames from 'classnames'

const Table = ({ result }) => {
  const student = result.tours[0].student

  return (
    <Fragment>
      <h3>
        { student.fullName }
      </h3>
      <CertificateButton
        className="btn btn--light-blue mt-gutter-s mb-gutter-m"
        student={student}
      />
      <ChildStatisticsTable {...result} />
    </Fragment>
  )
}

const Content = ({ statistics }) => {
  if (!statistics.object || !statistics.object.length) { return null }

  return _.map(statistics.object, (result, index) => {
    if (!result.tours.length) { return null }
    return (
      <div
        key={`table-wrapper-${result.student_id}`}
        className={
          classnames(
            "plate plate--xxl",
            {'mt-2': index !== 0}
          )
        }>
        <Table result={result} />
      </div>
    )
  })
}

const Statistics = ({ route, parent }) => {
  return (
    <Fragment>
      <div className="page__inner mt-1 mb-gutter-m">
        <h1 className="plate-heading plate-heading--left m-0" style={{ color: 'rgba(9, 21, 38, .85)' }}>
          { I18n.t('teachers.show.statistic') }
        </h1>
      </div>
      <StatisticsContainer ChildComponent={Content} />
    </Fragment>
  )
}

Statistics.propTypes = {
  route: PropTypes.object.isRequired
}

export default Statistics
